import { APP_API_URL } from "@services/api-config.service"

import { apiGet, apiPost, systemRequestConfig } from '@api/api.utils'
import { IResponseCommon } from "@api/common.types"
import { IResponseLogin, IResponseUserProfile } from "./api.types"


const route = '/auth'

export interface ISessionHeartbeatPayload {
    pageName?: string
    pagePath?: string
    isActivity?: boolean
}

/** Авторизация пользователя */
export const auth = (login: string, password: string): Promise<IResponseLogin> => 
    apiPost<IResponseLogin>(`${route}/login`, undefined, { login, password})

/** Проверка авторизации пользователя */
export const checkAuth = (): Promise<IResponseLogin> =>
    apiGet<IResponseLogin>(`${APP_API_URL}${route}/refresh`)

/** Выход из системы */
export const logout = (): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/logout`)

/** Получение данных по профилю текущего пользователя */
export const getUserProfile = (): Promise<IResponseUserProfile> =>
    apiGet<IResponseUserProfile>(`${route}/getUserProfile`)

/** Лёгкий heartbeat активной сессии */
export const pingSession = (payload?: ISessionHeartbeatPayload): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/ping`, systemRequestConfig(), payload)